/* istanbul ignore file
NOTE: Hooks are being properly tested, but the coverage isn't registering the tests
for the nullish operators
*/
import { useAccount } from 'reservations/account/providers/AccountProvider';

const usePayments = () => useAccount()?.payment_provider_information;

export const usePaymentProvider = () => usePayments()?.payment_provider ?? '';

export const useCloverPayments = () => ({
  cloverPaymentFormUrl: usePayments()?.clover_payment_form_url ?? '',
  cloverPlatformPublicKey: usePayments()?.clover_platform_public_key ?? ''
});

export const useStripePayments = () =>
  usePayments()?.stripe_publishable_key ?? '';
